import * as React from 'react';
import SamsungPayBox from '../../components/common/SamsungPayBox';
import SamsungPayHeader from '../../components/common/SamsungPayHeader';
import ReturnToStoreButton from '../../components/buttons/ReturnToStoreButton';
import cancelLogo from '../../assets/pay_online_payment_cancel_2.png';
import { useTranslation } from "react-i18next";
import styles from '../../css/pc/PcGeneral.module.css';
import classNames from 'classnames/bind';
import { POST_MESSAGE_CONTENT_MESSAGE } from '../../common/constants';

const cx = classNames.bind(styles);

export default function UpdateAppPage() {
  const { t } = useTranslation();

  return(
    <SamsungPayBox>
      <SamsungPayHeader headerMessage={"pay.gsmpi.done.msg1"}/>
      <div className="mpi-dynamic-space-div"></div>
      <div className="mpi-content">
        <div>
          <div style={{textAlign: 'center'}}><img src={cancelLogo} alt="" className={cx('mpi-unable-img')}/></div>
          <div style={{textAlign: 'center'}} className={cx('mpi-body-msg-div1')}>
            {t('pay.gsmpi.app.update.msg').replace('%s', 'Samsung Wallet')}
          </div>
        </div>
      </div>
      <div className="mpi-boxbottom">
        <ReturnToStoreButton reasonMessage={POST_MESSAGE_CONTENT_MESSAGE.APP_UPDATE_REQUIRED}/>
      </div>
    </SamsungPayBox>
  );
}
